<template>
  <div class="user-creation-dialog">
    <v-card>
      <v-card-title>
        <span class="headline">New user</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row no-gutters>
            <v-col sm="12" md="6" class="pa-1">
              <v-text-field
                label="last name*"
                placeholder="Last name..."
                outlined
                :rules="nameRules"
                v-model="lastName"
                required
                dense
              ></v-text-field>
            </v-col>
            <v-col sm="12" md="6" class="pa-1">
              <v-text-field
                label="first name*"
                placeholder="First name..."
                outlined
                :rules="nameRules"
                v-model="firstName"
                required
                no-resize
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                class="mx-1"
                label="email*"
                placeholder="Email..."
                outlined
                :rules="emailRules"
                v-model="email"
                required
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" @click="cancel">Cancel</v-btn>
          <v-btn :disabled="!valid" color="success" class="mr-4" @click="submit">Create</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      valid: false,
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      nameRules: [v => !!v || "Name is required"]
    };
  },
  methods: {
    submit() {
      this.$emit("submit", this.lastName, this.firstName, this.email);
    },
    reset() {
      this.lastName = "";
      this.firstName = "";
      this.email = "";
    },
    cancel() {
      this.$emit("cancel");
      this.reset();
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style>
</style>